var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-block"},[_c('div',{staticClass:"texts"},[_c('div',{staticClass:"title"},[_c('span',{style:(_vm.styleClass)},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('br'),_c('div',{staticClass:"description"},[_c('span',{style:(_vm.styleClass)},[_vm._v(" "+_vm._s(_vm.description)+" ")]),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }